import { userRolesMap } from '../helpers/auth';

export * from './services';
export * from './acl';

export const pagesMap = {
  workspaceTemplates: {
    slug: 'workspace-templates',
    displayName: 'Workspace Templates',
    accessLevel: userRolesMap.ngAdmin,
  },
};

export const listActionTypes = {
  MOVE_UP: 'MOVE_UP',
  MOVE_DOWN: 'MOVE_DOWN',
  REMOVE: 'REMOVE',
  OPEN_SETTINGS: 'OPEN_SETTINGS',
};

export const projectPagesMap = {
  QUERY: {
    displayName: 'Query',
    slug: 'query',
  },
  QUERIES: {
    displayName: 'Queries',
    slug: 'queries',
  },
  DATA: {
    displayName: 'Data',
    slug: 'data',
  },
  DOCUMENTS: {
    displayName: 'Documents',
    slug: 'documents',
  },
  UPLOADED_DATA: {
    displayName: 'Uploaded Data',
    slug: 'data-uploaded',
  },
  ENTITIES: {
    displayName: 'Entities',
    slug: 'entities',
  },
  VALUES: {
    displayName: 'Values',
    slug: 'values',
  },
  ETL: {
    displayName: 'Etl',
    slug: 'etl',
  },
  TEMPLATES: {
    displayName: 'Templates',
    slug: 'templates',
  },
  WORKSPACE_SETTINGS: {
    displayName: 'Settings',
    slug: 'settings',
  },
  BLOCKS: {
    displayName: 'Blocks',
    slug: 'blocks',
  },
};

export enum GrantAccessLevel {
  EDITOR = 'editor',
  VIEWER = 'viewer',
  DATA_ADMIN = 'data-admin',
}

export const GrantAccessLevelToDisplayNameMap = {
  [GrantAccessLevel.VIEWER]: 'Viewer',
  [GrantAccessLevel.EDITOR]: 'Editor',
  [GrantAccessLevel.DATA_ADMIN]: 'Data Admin',
};
